<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import baseInput from './baseInput'

export default {

    name: 'date-input',

    components: {flatPickr},

    mixins: [ baseInput ],

    props: {
        icon: String,
        placeholder: String,
        value: String,
        disabled: Boolean,
        noRadius: Boolean,
    },

    data:() =>({
        config: {
            wrap: true,
            altFormat: 'j M, Y',
            altInput: true,
            dateFormat: 'Y-m-d',
        },
    }),

}
</script>

<template lang="html">
    <div class="engage-simple-input engage-date-input" :class="{'no-radius': noRadius}">
        <div class="form-group">
            <div class="input-group">

                <flat-pickr
                        v-model="internalValue"
                        :config="config"
                        class="form-control"
                        :class="{ 'iconed' : icon, 'pl-3 border-radius-2' : !icon }"
                        :placeholder="placeholder"
                        name="date">
                </flat-pickr>

                <div v-if="icon" class="input-group-addon text-center simpleInput" :class="{ 'disabled' : disabled }">
                    <i :class="icon"></i>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/dateInput.vue